__turbopack_context__.v({
  "container": "Spinner-module-scss-module__rrhiKG__container",
  "hidden": "Spinner-module-scss-module__rrhiKG__hidden",
  "line-break": "Spinner-module-scss-module__rrhiKG__line-break",
  "spin": "Spinner-module-scss-module__rrhiKG__spin",
  "spinner": "Spinner-module-scss-module__rrhiKG__spinner",
  "text-align_center": "Spinner-module-scss-module__rrhiKG__text-align_center",
  "wrapper": "Spinner-module-scss-module__rrhiKG__wrapper",
});
